/* global $ */
/* eslint-disable */
import log from '@/logger';
import store from '@/store';

const STATES = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];
const reconnectTimeout = 5 * 1000;
let channelMarketHub = null;
let connection = null;
let reconnectDisabled = false;

function createConnection({ apiToken, onUpdate }) {
  log.info('socket::', 'createConnection::', apiToken);
  if (typeof $ !== 'undefined' && typeof $.hubConnection !== 'undefined') {
    connection = $.hubConnection(process.env.SIGNALR_URL, {
      useDefaultPath: false,
    });
    channelMarketHub = connection.createHubProxy('marketHub');
    if (apiToken) {
      setToken({ apiToken });
    }
    if (isConnected()) {
      addListener({ onUpdate });
      connect();
    }
    return true;
  }
  return false;
}

const isConnected = () => connection !== null;

const connect = () => {
  if (!isConnected()) return;
  channelMarketHub.on('update', (objectType, object) => {
    log.info('socket::', 'marketHub::', 'update::', objectType, object);
  });
  connection
    .start()
    .done((state) => {
      log.info('socket::', 'connection::', 'connected::', state.id, state);
      store.dispatch('app/setSignalrInitialized', true);
    })
    .fail((error) => {
      log.info('socket::', 'connection::', 'errored::', error);
      if (reconnectDisabled) {
        log.info('socket:: reconnect-disabled::');
      } else {
        setTimeout(() => {
          log.info('socket:: reconnect::');
          connection.start();
        }, reconnectTimeout);
      }
    });
  connection.starting(() => {
    log.info('socket:: starting::');
  });
  connection.received((data) => {
    log.info('socket::', 'received::', data);
  });
  connection.connectionSlow(() => {
    log.info('socket:: connectionSlow::');
  });
  connection.reconnecting(() => {
    log.info('socket:: reconnecting::');
  });
  connection.reconnected(() => {
    log.info('socket:: reconnected::');
    store.dispatch('app/setSignalrInitialized', true);
  });
  connection.stateChanged((change) => {
    log.info('socket:: stateChanged::', STATES[change.oldState], ' => ', STATES[change.newState]);
  });
  connection.disconnected(() => {
    log.info('socket:: disconnected::', connection.lastError);
    if (reconnectDisabled) {
      log.info('socket:: reconnect-disabled::');
    } else {
      setTimeout(() => {
        log.info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  window.onbeforeunload = () => {
    if (connection !== null) {
      connection.stop();
    }
  };
};


const addListener = (options) => {
  log.info('socket::', 'adding listener');
  const { onUpdate = () => null } = options;
  channelMarketHub.on('update', (objectType, object) => {
    onUpdate('update', objectType, object);
  });
};

const setToken = (options) => {
  const { apiToken = null } = options;
  if (apiToken !== null && connection !== null) {
    log.info('socket:: token present, add bearer');
    connection.qs = { bearer: apiToken };
  }
};

const forceReconnect = ({ apiToken, onUpdate }) => {
  if (document.readyState !== 'complete') return;
  if (!isConnected()) return;
  log.info('socket::', 'forceReconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
  if (!apiToken) return;
  const created = createConnection({ apiToken, onUpdate });
  if (created) {
    reconnectDisabled = false;
  }
};

const forceDisconnect = () => {
  if (!isConnected()) return;
  log.info('socket:: forceDisconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
};

export {
  setToken,
  addListener,
  connect,
  forceReconnect,
  createConnection,
  isConnected,
  forceDisconnect,
};



// WEBPACK FOOTER //
// ./src/services/notifications/signal-r.js